const MAX = 100; // simple LRU cap

export function set(state, { id, item, ctx = "" }) {
  state.byId[id] = { item, ts: Date.now(), ctx };
  const i = state.order.indexOf(id);
  if (i !== -1) state.order.splice(i, 1);
  state.order.push(id);
  if (state.order.length > MAX) {
    const evict = state.order.shift();
    delete state.byId[evict];
  }
}

export function setInflight(state, { id, p }) {
  state.inflight[id] = p;
}
export function clearInflight(state, id) {
  delete state.inflight[id];
}
